module.exports = __webpack_public_path__ + "img/bing_bing.895467f6.png";